import * as React from 'react';
import TextField from '@mui/material/TextField';
import {
    Box,
    Grid,
} from '@mui/material';

export default function RedQuickTextArea(props: any) {
    return (
        <Box sx={{ p: 2 }}>
            <Grid item xs={12} sm={12} lg={12} sx={{ pt: { xs: 2, sm: '0 !important' } }}>
                <TextField
                    defaultValue=""
                    error={!!props.invalid}
                    fullWidth
                    value={props.value || ''}
                    label={props.title || ''}
                    disabled={props.disabled}
                    required={props.required}
                    type={props.type}
                    multiline
                    minRows={4}
                    variant="standard"
                    onChange={(evt) => {
                        if (props.onChange) {
                            props.onChange(evt.currentTarget.value);
                        }
                    }} />
            </Grid>
        </Box>
    );
}
